import moment from 'moment'
import { KIDS_FLY_FREE_CAMPAIGN_TAG, MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG } from 'constants/charterFlight'

const KIDS_FLY_FREE_DATES = [
  '2026-06-08',
  '2026-06-15',
  '2026-07-27',
  '2026-08-03',
  '2026-08-10',
  '2026-08-17',
  '2026-08-24',
  '2026-08-31',
  '2026-09-07',
  '2026-09-14',
] as const

const kidsFlyFreeDateSet = new Set<string>(KIDS_FLY_FREE_DATES)

export function isKidsFlyFreeDate(date: string): boolean {
  return kidsFlyFreeDateSet.has(date)
}

export function hasKidsFlyFreeDateInMonth(year: number, month: number): boolean {
  return KIDS_FLY_FREE_DATES.some(d => {
    const parsed = moment(d)
    return parsed.year() === year && parsed.month() === month
  })
}

/**
 * Determines whether to show the Kids Fly Free label.
 * Requires offer to have Maldives charter bundle campaign tag, then:
 * - No date selected → show (promotional visibility)
 * - Date selected and departure is a Kids Fly Free date → show
 * - Date selected and departure is NOT a Kids Fly Free date → hide
 *
 * Charter flights depart the day before hotel check-in.
 */
export function shouldShowKidsFlyFreeLabel(
  offer: { campaignTags?: Array<string> },
  checkInDate?: string,
): boolean {
  if (!offer.campaignTags?.includes(MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG)) return false
  if (!offer.campaignTags?.includes(KIDS_FLY_FREE_CAMPAIGN_TAG)) return false
  if (!checkInDate) return true
  const departDate = moment(checkInDate).subtract(1, 'day').format('YYYY-MM-DD')
  return isKidsFlyFreeDate(departDate)
}
